import React from 'react'
import { Order } from 'views/purchase/Order'

export const OrderPage = () => {
  return <Order />
}
